import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";

export const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.checkIns.dataPoints);
  const isUserQa = useSelector((state) => state.checkIns.currentUser.qa);

  return (
    <div className="data-points">
      {dataPoints.map((dataPoint) => {
        return (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay
              key={dataPoint.label}
              label={dataPoint.label}
              value={Math.round(dataPoint.total_checkins)}
              url={dataPoint.url}
              disableAnimation={isUserQa}
              changeProps={{
                changeValue: dataPoint.growth,
                toolTip: "Percentage change from previous period",
                showBorder: true
              }}
            />
          </div>
        );
      })}
    </div>
  );
});
